// Third-party libraries
import 'reflect-metadata';

// App API
import { API_METADATA } from '../metadata/api.metadata';
import { HttpMethod, RouteMetadata } from '../types';

function createHttpMethodDecorator(method: HttpMethod) {
  return (path: string = ''): MethodDecorator => {
    return (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
      const existingRoutes: RouteMetadata[] = Reflect.getOwnMetadata(API_METADATA.ROUTES, target.constructor) || [];

      existingRoutes.push({
        method,
        path,
        methodName: propertyKey as string
      });

      Reflect.defineMetadata(API_METADATA.ROUTES, existingRoutes, target.constructor);

      return descriptor;
    };
  };
}

export const GET = createHttpMethodDecorator(HttpMethod.GET);
export const POST = createHttpMethodDecorator(HttpMethod.POST);
export const PUT = createHttpMethodDecorator(HttpMethod.PUT);
export const DELETE = createHttpMethodDecorator(HttpMethod.DELETE);
export const PATCH = createHttpMethodDecorator(HttpMethod.PATCH);

